import axios from 'axios';

import { requestConfig } from '../constants';

function getStreetsForCity(cityId, term) {
  return axios.post('/checkconnection/GetStreets/', { cityId, term }, requestConfig);
}

export default getStreetsForCity;
